// SecretId AKIDud8NcJpY3IXg6V24tT5f8Pg3WsGodJlz
// SecretKey EI9h7IWpvnT8GXjwMwPeojkTtUuCJCsK

import COS, { ProgressInfo } from 'cos-js-sdk-v5'

// const allowType = {
//   image: [{ jpg: 'image/jpeg' }, { png: 'image/png' }, { jpeg: 'image/jpeg' }]
// }
// ["jpg", "png", "jpeg"]
class OssTXY {
  private readonly SecretId = 'AKIDud8NcJpY3IXg6V24tT5f8Pg3WsGodJlz'
  private readonly SecretKey = 'EI9h7IWpvnT8GXjwMwPeojkTtUuCJCsK'
  cos: any

  constructor() {
    // 填写自己腾讯云cos中的key和id (密钥)
    this.cos = new COS({
      SecretId: this.SecretId, // 身份识别ID
      SecretKey: this.SecretKey // 身份秘钥
    })
  }

  getFileSuffix(fileItem: any) {
    if (fileItem?.file?.type.includes('image')) {
      return 'images'
    }

    if (fileItem?.file?.type.includes('video')) {
      return 'videos'
    }

    if (fileItem?.file?.type.includes('audio')) {
      return 'audios'
    }

    if (fileItem?.file?.type.includes('excel')) {
      return 'excels'
    }

    if (fileItem?.file?.type.includes('pdf')) {
      return 'pdfs'
    }

    return 'commons'
  }

  upload(fileItem: any | any[], processCallback?: (percent: number, progressInfo?: ProgressInfo) => void): Promise<string> {
    return new Promise((resolve, reject) => {
      const nowTime = new Date()
      const yearAndMonth = `${nowTime.getFullYear()}-${nowTime.getMonth() + 1}`
      this.cos.uploadFile(
        {
          Bucket: 'btkl-1318756768' /* 存储桶 */,
          Region: 'ap-shanghai' /* 存储桶所在地域，必须字段 */,
          StorageClass: 'STANDARD', // 上传模式, 标准模式
          Body: fileItem.file, // 上传文件对象\
          Key: `${this.getFileSuffix(fileItem)}/${yearAndMonth}/${nowTime.getTime()}-${fileItem.file.name}`,
          /* Key: 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段。也就是上传后的文件在桶中的位置
      如果想要放在text文件下，可以定义为text/文件名。文件地址可以前端自己定义，也可以后端返回。 */
          onProgress: (progressInfo: ProgressInfo) => {
            // 上传进度回调，不过感觉不怎么样

            let percent: number = 0
            if (progressInfo.percent >= 0 && progressInfo.percent <= 0.5) {
              percent = 50
              processCallback?.(50, progressInfo)
            }
            if (progressInfo.percent > 0.5) {
              // 0 ~ 100
              setTimeout(() => {
                percent = (progressInfo.loaded / progressInfo.total) * 100
                processCallback?.(percent, progressInfo)
              }, 800)
            }

            // processCallback?.(percent, progressInfo)
          }
        },
        (err: any, data: any) => {
          // 上传成功之后
          if (data.statusCode === 200) {
            const url = `https://${data.Location}`
            resolve(url)
          } else {
            reject(err)
          }
        }
      )
    })
  }
}

const ossTXY = new OssTXY()
export default ossTXY
export { ossTXY }
